import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SeatingchartviewerComponent } from './seatingchartviewer.component';
import { SeatingchartviewerRoutingModule } from './seatingchartviewer-routing.module';
import { SubmenuModule } from '../layout/submenu/submenu.module';
import { FormsModule } from '@angular/forms';
@NgModule({
  declarations: [SeatingchartviewerComponent],
  imports: [FormsModule, CommonModule, SeatingchartviewerRoutingModule, SubmenuModule],
})
export class SeatingchartviewerModule {}
